import { parseDef } from "../parseDef.js";

//#region src/utils/zod-to-json-schema/parsers/promise.ts
function parsePromiseDef(def, refs) {
	return parseDef(def.type._def, refs);
}

//#endregion
export { parsePromiseDef };
//# sourceMappingURL=promise.js.map